<template>
  <div>
    <template v-for="(field, id) in fields">
      <RangeInput
        v-if="field.type === 'range-input'"
        :key="`${id}_range-input`"
        :fields="field"
        class="mb-2"
      />
      <ValueHelpWrapper
        v-else-if="field.type == 'value-help-v2'"
        :key="field.name"
        :field="getFieldWithDisabled(field)"
        :value="getFieldValue(field)"
        :fullObject="getFieldFullObject(field)"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <FormulateInput
        v-else-if="field.type == 'button-group'"
        :key="`${id}_button-group`"
        type="group"
        name="status_type"
        :label="field.label"
        :value="(formValues.status_type = status_type)"
      >
        <div class="mc-modal__filter-button-group">
          <template v-for="item in statusTypeOptions">
            <button
              :key="`${item.key}-${btnKey}`"
              type="button"
              :class="{ 'mc-modal__filter-button--active': status_type[item.key] }"
              class="mc-modal__filter-button"
              @input="$emit('update:formValues', { key: field.name, value: $event })"
              @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
              @click="filterStatus(item.key)"
            >
              {{ item.label }}
            </button>
          </template>
        </div>
      </FormulateInput>
      <FormulateInput v-else :key="id" v-bind="field" class="mb-2" />
    </template>
  </div>
</template>

<script>
import { tabelFilterFields } from './lib/tabelFilterFields'
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'
import RangeInput from './wrapper/RangeInput.vue'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    RangeInput,
    ValueHelpWrapper,
  },
  props: {
    formValues: {},
    fullObjects: {},
    isCreating: {
      type: Boolean,
      default: true,
    },
    isSingleProductCategory: {
      type: Boolean,
      default: false,
    },
    userGroup: {
      type: Object,
      default: null,
    },
    // allows parent to disable specific fields by name, e.g. { box_type_id: true }
    disabledFields: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:formValues', 'update:fullObjects'],
  data() {
    return {
      btnKey: 0,
    }
  },
  computed: {
    ...mapState('delivery', ['statusTypeFilters']),
    fields() {
      return tabelFilterFields(this, {
        isCreating: this.isCreating,
        userGroup: this.userGroup,
        productCategoryId: this.productCategoryId,
        isSingleProductCategory: this.isSingleProductCategory,
      }).filter((field) => field?.isShow)
    },
    status_type: {
      get() {
        return Object.keys(this.statusTypeFilters).length > 0
          ? this.statusTypeFilters
          : { all: true }
      },
      set(value) {
        this.setStatusTypeFilters(value)
      },
    },
    statusType() {
      return [
        {
          key: 'CONFIRMED',
          label: this.$t('delivery.status.confirmed'),
        },
        {
          key: 'RESCHEDULED',
          label: this.$t('delivery.status.rescheduled'),
        },
        {
          key: 'SCHEDULED',
          label: this.$t('delivery.status.scheduled'),
        },
        {
          key: 'IN_TRANSIT',
          label: this.$t('delivery.status.inTransit'),
        },
      ]
    },
    statusTypeOptions() {
      const data = this.statusType
      data.unshift({
        key: 'all',
        label: this.$t('global.filter.all'),
      })
      return data
    },
    productCategoryId() {
      return this.fullObjects?.['product_category_id']?.[0]?.id ?? null
    }
  },
  watch: {
    fields: {
      immediate: true,
      handler(fields) {
        fields.forEach((field) => {
          if (field && field.name && this.formValues[field.name] === undefined && field.value !== undefined) {
            this.$emit('update:formValues', { key: field.name, value: field.value })
          }
        })
      },
    },
  },
  methods: {
    ...mapActions('delivery', ['setStatusTypeFilters']),
    getFieldValue(field) {
      if (field.name === 'user_group_id' && !this.isCreating && this.userGroup?.id != null) {
        return this.formValues[field.name] || [Number(this.userGroup.id)]
      }
      return this.formValues[field.name]
    },
    getFieldFullObject(field) {
      if (field.name === 'user_group_id' && !this.isCreating && this.userGroup != null) {
        return this.fullObjects[field.name] || [this.userGroup]
      }
      return this.fullObjects[field.name] || []
    },
    getFieldWithDisabled(field) {
      const disabled = this.disabledFields && this.disabledFields[field.name]
      if (disabled !== undefined) return { ...field, disabled }
      return field
    },
    filterStatus(key) {
      if (key == 'all') {
        this.status_type = this.statusTypeOptions.reduce((acc, item) => {
          acc[item.key] = false
          return acc
        }, {})
        this.status_type.all = true
      } else {
        this.status_type.all = false
        this.status_type[key] = !this.status_type[key]
        let obj = { ...this.status_type }
        let objArr = []
        Object.keys(obj).forEach(function (key) {
          if (obj[key]) {
            objArr.push(true)
          }
        })
        if (objArr.length === this.statusType.length || objArr.length === 0) {
          this.status_type = this.statusTypeOptions.reduce((acc, item) => {
            acc[item.key] = false
            return acc
          }, {})
          this.status_type.all = true
          return
        }
      }
      this.btnKey += 1
      this.setStatusTypeFilters(this.status_type)
    },
  },
}
</script>
